import React from 'react';
import AlertModal from './AlertModal';

const PROMPT_OVERLAY = {
  presentation: 'prompt',
  overlayOpacity: 0.16,
  overlayColor: '15, 23, 42',
  overlayBlur: 2,
};

/**
 * Success feedback — compact slide-up sheet (matches profile / AlertModal prompt style).
 */
const SuccessModal = ({
  isOpen,
  onClose,
  title = 'Success!',
  message,
  details,
  style = {},
  zIndex = 1000,
  confirmLabel = 'Great!',
}) => (
  <AlertModal
    isOpen={isOpen}
    onClose={onClose}
    variant="success"
    subject={title}
    body={message}
    details={details}
    style={style}
    zIndex={zIndex}
    allowOverlayClose
    actions={[{ label: confirmLabel, onClick: onClose, variant: 'primary' }]}
    {...PROMPT_OVERLAY}
  />
);

export default SuccessModal;
